// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hENW6{display:flex;flex-direction:column;gap:8px;margin-bottom:16px}.o9Hg3{padding-left:28px;display:flex;align-items:center;gap:8px;margin-top:16px}.xBwx1{margin-top:16px;height:40px}.wBnEf{flex-shrink:0;text-align:center}.RLcLg{display:flex;align-items:center;gap:8px}.RLcLg.jh7Ek{gap:4px}.r8kh3{display:flex;flex-direction:row;align-items:center;gap:15px}.ynHHD{display:flex;flex-direction:row;align-items:center;gap:7px}.XayPt{display:flex;flex-direction:row;align-items:center;gap:8px}.pA74d{display:flex;align-items:center;gap:4px}.nd4Ns{text-align:center}.hCMrX{display:flex;justify-content:center}.Ujwst{opacity:1;transition:opacity 300ms ease-in-out}.Ujwst.O7oWt{opacity:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settings": `hENW6`,
	"additionalControl": `o9Hg3`,
	"roundPrices": `xBwx1`,
	"noShrink": `wBnEf`,
	"container": `RLcLg`,
	"compactGap": `jh7Ek`,
	"rowAndIconContainer": `r8kh3`,
	"rowContent": `ynHHD`,
	"addSettingsButton": `XayPt`,
	"optionalInlineSelectContainer": `pA74d`,
	"limitChargesSelect": `nd4Ns`,
	"limitChargesSelectItem": `hCMrX`,
	"settingWrapper": `Ujwst`,
	"exiting": `O7oWt`
};
export default ___CSS_LOADER_EXPORT___;
